export let multiDayAllDayFormatString = "s_eGOc";
export default {multiDayAllDayFormatString};